import styled from 'styled-components';
import { Button as uikitButton } from 'components/uikit/Button/Button';

export const Button = styled(uikitButton).attrs(() => ({ theme: 3 }))`
  margin-top: -8px;
  margin-bottom: -8px;
`;
